/* Improve navigation around the existing Shopify product configurators. */
(function () {
  'use strict';

  function start() {
    const sheet = document.getElementById('sizePickerSheet');
    const trigger = document.getElementById('sizePickerTrigger');
    const close = document.getElementById('sizePickerClose');
    const scrim = document.getElementById('sizePickerScrim');

    if (sheet && trigger && close && !sheet.dataset.mmFocusReady) {
      sheet.dataset.mmFocusReady = 'true';
      let wasOpen = false;
      let previousOverflow = '';
      let background = [];
      function focusable() {
        return Array.from(sheet.querySelectorAll('button, a[href], input, select, [tabindex="0"]'))
          .filter(el => !el.disabled && !el.inert && el.getClientRects().length > 0);
      }
      function syncSheet() {
        const open = sheet.classList.contains('open');
        sheet.inert = !open;
        if (open === wasOpen) return;
        wasOpen = open;
        if (open) {
          background = [];
          for (let node = sheet; node.parentElement; node = node.parentElement) {
            for (const sibling of node.parentElement.children) {
              if (sibling === node || sibling === scrim || sibling.contains(scrim)) continue;
              if (['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) continue;
              background.push([sibling, sibling.inert]);
              sibling.inert = true;
            }
            if (node.parentElement === document.body) break;
          }
          requestAnimationFrame(() => {
            if (wasOpen && sheet.classList.contains('open')) {
              (sheet.querySelector('.size-picker-tile.on') || close).focus({ preventScroll: true });
            }
          });
        } else {
          for (const [element, inert] of background) element.inert = inert;
          background = [];
          document.body.style.overflow = previousOverflow;
          trigger.focus({ preventScroll: true });
        }
      }
      trigger.addEventListener('click', () => {
        if (!sheet.classList.contains('open')) previousOverflow = document.body.style.overflow;
      }, true);
      sheet.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close.click(); return; }
        if (event.key !== 'Tab') return;
        const items = focusable();
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
      document.addEventListener('focusin', event => {
        if (wasOpen && !sheet.contains(event.target)) close.focus({ preventScroll: true });
      });
      new MutationObserver(syncSheet).observe(sheet, { attributes: true, attributeFilter: ['class'] });
      syncSheet();
    }

    const hero = document.querySelector('.story-hero');
    const buy = document.getElementById('buy');
    const bar = document.getElementById('stickyBar');
    if (hero && buy) {
      hero.classList.add('mm-shopping-hero');
      const gallery = document.getElementById('pgGallery');
      if (gallery && gallery.parentElement === hero.parentElement && !hero.closest('.mm-product-intro')) {
        const intro = document.createElement('div');
        intro.className = 'mm-product-intro';
        gallery.before(intro);
        intro.append(gallery, hero);
      }
      const configureLink = hero.querySelector('.story-price-hint > a');
      const separator = configureLink && configureLink.previousSibling;
      if (separator && separator.nodeType === Node.TEXT_NODE) {
        separator.textContent = separator.textContent.replace(/\s*[·•]\s*$/, ' ');
      }
    }
    function setupSticky(hero, buy, bar) {
      if (!hero || !buy || !bar || bar.dataset.mmShoppingReady) return;
      bar.dataset.mmShoppingReady = 'true';
      const original = bar.querySelector('.sticky-btn, .abp-sticky-btn');
      if (original) {
        const configure = document.createElement('a');
        configure.className = 'sticky-btn';
        configure.href = '#' + buy.getAttribute('id');
        configure.textContent = 'Configure yours';
        // The main purchase action stays in the configurator, beside the chosen options.
        original.hidden = true;
        original.style.setProperty('display', 'none', 'important');
        original.after(configure);
      }
      bar.classList.add('mm-shopping-sticky');
      let pending = false;
      function syncBarAccessibility() {
        const hidden = bar.dataset.visible !== 'true';
        bar.inert = hidden;
        if (bar.getAttribute('aria-hidden') !== String(hidden)) {
          bar.setAttribute('aria-hidden', String(hidden));
        }
      }
      function updateBar() {
        pending = false;
        const title = hero.querySelector('h1') || hero;
        const rect = buy.getBoundingClientRect();
        const buyVisible = rect.top < window.innerHeight && rect.bottom > 0;
        buy.dataset.mmInView = String(buyVisible);
        const show = window.innerWidth < 768 && title.getBoundingClientRect().bottom < 0 && !buyVisible;
        bar.dataset.visible = String(show);
        syncBarAccessibility();
      }
      function schedule() {
        if (!pending) { pending = true; requestAnimationFrame(updateBar); }
      }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      // Older section observers may still update aria-hidden around their bottom CTA.
      new MutationObserver(syncBarAccessibility).observe(bar, { attributes: true, attributeFilter: ['aria-hidden'] });
      updateBar();
    }
    setupSticky(hero, buy, bar);
    setupSticky(document.getElementById('abpRoot'), document.getElementById('abpForm'), document.getElementById('abpSticky'));

    document.querySelectorAll('#feelPills, #sizePills, #sizePickerSheet, .ab-grid').forEach(group => {
      const choices = group.querySelectorAll('.feel-pill, .size-pill, .size-picker-tile, .ab-card');
      function syncSelection() {
        choices.forEach(choice => choice.setAttribute('aria-pressed',
          String(choice.classList.contains('active') || choice.classList.contains('on'))));
      }
      new MutationObserver(syncSelection).observe(group, { subtree: true, attributes: true, attributeFilter: ['class'] });
      syncSelection();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
